import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { handleCopy } from "./CopyDocID";
import "./Ariane.css";

const Ariane = ({
  modelName = [],
  onChangeConfigKey,
  mode = "default",
  ModelName = "",
  instanceName = "",
  instanceId = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedModel, setSelectedModel] = useState("{}");
  const [hover, setHover] = useState(false);
  const configkeyset = Cookies.get("configkey");
  const role = Cookies.get("Role");
  const clientId = Cookies.get("clientId");
  const modelIdHome = Cookies.get("modelIdHome");
  const selectedElement = clientId != undefined ? clientId : modelIdHome;

  // Initialise le modèle sélectionné depuis les cookies si disponible.
  useEffect(() => {
    const savedId = Cookies.get("modelId");
    if (
      savedId &&
      savedId !== "all" &&
      modelName.length > 0 &&
      configkeyset !== "DefaultLots"
    ) {
      const model = modelName.find(
        (m) => m.id.toString() === savedId && m.component,
      );
      if (model) {
        const selectedValue = JSON.stringify({
          id: model.id,
          component: model.component,
          name: model.name,
        });
        setSelectedModel(selectedValue);
      }
    } else {
      setSelectedModel("{}");
    }
  }, [modelName, configkeyset]);

  // Met à jour le modèle sélectionné, les cookies et redirige selon le composant associé.
  const handleModelChange = (event) => {
    const selectedValue = JSON.parse(event.target.value);
    setSelectedModel(event.target.value);

    if (selectedValue.id) {
      Cookies.set("modelId", selectedValue.id);
      if (onChangeConfigKey && selectedValue.component) {
        onChangeConfigKey(selectedValue.component);
        navigate(`/User/${selectedValue.component}Lots`);
        Cookies.set(
          "configkey",
          selectedValue.component.charAt(0).toUpperCase() +
            selectedValue.component.slice(1) +
            "Lots",
        );
      }
    } else {
      Cookies.set("modelId", "");
      if (onChangeConfigKey) {
        onChangeConfigKey("Default");
        navigate(`/User/DefaultLots`);
      }
    }
  };

  if (mode === "detailed") {
    return (
      <div className="ariane-container">
        <Link to={`/User/${configkeyset}`} className="ariane-link">
          {t("AllModels")}
        </Link>
        <p className="ariane-separator">{" > "}</p>
        <p
          className="ariane-clickable"
          onClick={() => navigate(`/User/${configkeyset}`)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {ModelName}
        </p>
        <p className="ariane-separator">{" > "}</p>
        <span className="ariane-clickable">{instanceName}</span>
        <CopyToClipboard
          text={instanceId}
          onCopy={() => handleCopy(instanceId)}
        >
          <button
            className="btn btn-sm "
            data-toggle="tooltip"
            title={t("Copy instanceId")}
          >
            <FontAwesomeIcon icon={faCopy} className="fa-copy" />
          </button>
        </CopyToClipboard>
        <p className="ariane-separator">{" > "}</p>
        <p className="ariane-text">Documents</p>
      </div>
    );
  }

  return (
    <div className="ariane-container">
      <p className="ariane-text">Instances</p>
      <p className="ariane-separator">{">"}</p>
      {modelName.length > 1 &&
      modelName.some((model) => model.component !== undefined) ? (
        <select
          className="form-select ariane-select"
          id="modelName"
          onChange={handleModelChange}
          value={selectedModel}
        >
          <option value="{}">{t("AllModels")}</option>
          {modelName
            .filter((model) => model.component !== undefined)
            .map((model) => (
              <option
                key={model.id}
                value={JSON.stringify({
                  id: model.id,
                  component: model.component,
                  name: model.name,
                })}
              >
                {model.name}
              </option>
            ))}
        </select>
      ) : (
        <span className="ariane-text">
          {modelName.length <= 1
            ? modelName[0]?.name
            : modelName.every((model) => model.component === undefined)
              ? t("AllModels")
              : null}
        </span>
      )}
    </div>
  );
};

export default Ariane;
